<template>
  <div
    v-tooltip="float && `${$t('innerpage.float_range')}: ${min} - ${max}`"
    class="bar__wrapper"
  >
    <div class="bar__desc">
      <template v-if="float">
        <ExteriorAB
          :key="getExteriorByFloat(float)"
          :name="getExteriorByFloat(float)"
        />
        <span>{{ float }}</span>
      </template>
      <template v-else>
        <span>{{ min }}</span>
        <span>{{ max }}</span>
      </template>
    </div>
    <div class="bar">
      <div
        :style="{ width: rightOffset, left: rightPosition }"
        class="bar__right"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import ExteriorAB from '~/components/ItemCard/Components/ExteriorAB.vue';
import { getExteriorByFloat } from '~/utils/floats';

const props = defineProps<{
  min: number
  max: number
  float?: number
}>();

const rightPosition = computed(() => {
  return `${(props.max || 1) * 100}%`;
});
const rightOffset = computed(() => {
  return `${101 - ((props.max || 1) * 100)}%`;
});
</script>

<style lang="scss" scoped>
.bar {
  position: relative;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right,
      #42D1AF 0%, #42D1AF 7%,
      #A3E363 7%, #A3E363 15%,
      #FFBB54 15%, #FFBB54 38%,
      #FF8539 38%, #FF8539 45%,
      #FF5353 45%, #FF5353 100%);
  overflow: hidden;
  border-radius: 4px;

  &__right {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    background: var(--surfaces-outline);
  }

  &__desc {
    display: flex;
    justify-content: space-between;
    color: var(--surfaces-on-surface-variable);
    font-size: 12px;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 4px;
  }
}
</style>
